var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex d-none user-nav"},[_c('b-avatar',{staticClass:"ml-1",attrs:{"id":"user-avatar","size":"40","variant":"primary","button":""}},[_vm._v(" "+_vm._s(_vm.userData.name.split('')[0])+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }